var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"1150px"},on:{"click:outside":function($event){return _vm.$emit('update:show', false)},"keydown":function($event){return _vm.$emit('update:show', false)}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('AuditLog',{attrs:{"logs":_vm.logs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }